import React from "react";
import { Menu, Typography, Button, ListSubheader } from "@mui/material";

import { UserData } from "../../context/auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faKey, faSignOut, faUser } from "@fortawesome/free-solid-svg-icons";
import { useUserManager } from "../EnsureLogin";
import { FormattedMessage } from "react-intl";
import CRUDFormDialog from "../CRUDFormDialog";
import { useNotification } from "../NotificationProvider";
import { Item } from "./shared";
import Applications from "./Applications";

type UserInfoProps = {
    userInfo: UserData;
};

function _getAccountInfoMenuItem(userInfo: UserData) {
    return <Item href={userInfo.accountPage} icon={faUser} label="account_info" />;
}

const PasswordChangeMenuItem: React.FC<{
    userInfo: UserData;
}> = ({ userInfo }) => {
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const { showSuccess } = useNotification();

    return (
        <>
            <Item
                href="/changepassword"
                onClick={() => setDialogOpen(true)}
                icon={faKey}
                label="change_password.create"
            />
            <CRUDFormDialog
                open={dialogOpen}
                titleId="change_password.create"
                hide={() => setDialogOpen(false)}
                resourceName="change_password"
                action="create"
                extraRequestData={{ user_id: userInfo.userId }}
                onSuccess={() => {
                    showSuccess(<FormattedMessage id="change_password_success" />, <FormattedMessage id="success" />);
                }}
            />
        </>
    );
};

const UserInfo = ({ userInfo }: UserInfoProps) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const userManager = useUserManager();

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const logout = (): void => {
        userManager.signoutRedirect({ post_logout_redirect_uri: window.location.origin });
    };
    const hasPasswordChange = global.identityProvider === "internal" && userInfo.userId;
    const hasAccountInfo = !hasPasswordChange && userInfo.userId;

    return (
        <div>
            <Button onClick={handleClick} sx={{ textTransform: "none" }}>
                <Typography variant="subtitle1" style={{ flexGrow: 1 }}>
                    {userInfo.name}
                </Typography>
                <FontAwesomeIcon icon={faChevronDown} style={{ marginLeft: 5 }} />
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
                <ListSubheader>
                    <FormattedMessage id="account.account" />
                </ListSubheader>
                {hasPasswordChange ? <PasswordChangeMenuItem userInfo={userInfo} /> : null}
                {hasAccountInfo ? _getAccountInfoMenuItem(userInfo) : null}
                <Item href="/logout" onClick={logout} icon={faSignOut} label="logout" />
                <Applications opened={open} />
            </Menu>
        </div>
    );
};

export default UserInfo;
